var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInviteFriends = function SvgInviteFriends(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 271 169",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.435 45.7431C171.678 44.9391 172.281 44.2861 172.543 43.4887C172.759 42.8325 172.733 42.1237 172.907 41.4575C173.222 40.3951 173.937 39.4971 174.902 38.9538C175.864 38.4221 176.934 38.1169 178.031 38.0613C180.376 37.8739 182.715 38.4881 184.667 39.8037C186.612 41.1365 187.971 43.1682 188.461 45.4773C188.556 46.2063 188.706 46.9271 188.91 47.6332C189.162 48.3223 189.67 48.9753 190.381 49.1525L190.312 49.9728C190.959 50.1033 191.553 50.422 192.019 50.889C192.485 51.356 192.804 51.9506 192.934 52.598C193.137 53.6907 192.777 54.8589 193.124 55.9155C193.452 56.8999 194.31 57.6415 194.435 58.6522C194.465 59.2754 194.341 59.8965 194.074 60.4603C193.565 61.786 193.012 63.092 192.416 64.3783C191.502 63.3939 190.548 62.4095 189.316 61.8779C188.576 61.5497 187.77 61.4382 187.023 61.1789C182.96 59.7876 181.049 54.9639 177.242 52.9754C176.387 52.5258 175.295 52.3781 174.489 51.8695C173.883 51.4856 173.867 50.9606 173.506 50.3962C172.527 48.8867 170.81 47.8399 171.435 45.7431Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.745 55.1247C173.981 56.2239 174.764 57.1198 175.587 57.8876C176.013 58.2847 176.481 58.6948 176.622 59.2625C176.647 59.4498 176.702 59.6317 176.786 59.8007C177.019 60.1288 177.54 60.0829 177.91 59.9057C178.351 59.6765 178.735 59.3511 179.033 58.9535C179.331 58.556 179.536 58.0964 179.634 57.6087C179.821 56.6309 179.707 55.619 179.306 54.7079C178.96 53.8663 178.439 53.1077 177.779 52.4821C177.119 51.8566 176.334 51.3782 175.476 51.0787C173.464 50.4782 173.483 53.8941 173.745 55.1247Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M270.474 103.723C270.923 99.5158 265.523 97.3566 261.299 97.2155C252.478 96.9234 243.805 99.1843 235.102 100.641C212.286 104.497 188.9 103.017 165.895 105.399C148.05 107.247 130.542 111.401 112.963 114.981C92.3196 119.181 71.5388 122.591 50.7055 125.708C40.515 127.234 30.2098 129.239 19.9439 130.115C15.209 130.522 2.16778 129.839 0.535984 136.635C0.146057 138.253 2.15467 139.313 3.75698 139.746C16.9883 143.336 30.236 146.926 43.7327 149.384C52.4913 150.982 61.3777 152.107 69.8546 154.828C77.2697 157.21 84.272 160.777 91.6643 163.208C104.185 167.326 117.521 168.091 130.68 168.82C133.957 169.003 137.233 169.18 140.461 168.639C144.616 167.94 148.469 166.076 152.257 164.232L264.73 109.488"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7961 59.8663L84.8193 48.5881C84.8193 48.5881 90.2619 45.9629 94.0268 48.2304C97.7918 50.4979 94.6035 58.1305 94.0268 60.5423C93.4501 62.9542 89.7376 63.8959 88.3254 62.7934C86.9131 61.6908 85.0651 64.9558 85.0651 64.9558L79.7961 59.8663Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.699 105.524L111.298 159.1C104.937 161.367 97.9942 161.395 91.6151 159.179L16.5557 133.085C15.9915 132.89 15.465 132.599 14.9993 132.225C14.0218 131.433 13.3926 130.289 13.2463 129.039C13.2199 128.827 13.2068 128.613 13.2069 128.399C13.1851 127.251 13.567 126.133 14.2859 125.239C15.0048 124.345 16.0148 123.733 17.139 123.51L24.1937 122.023L100.233 105.98L183.081 88.4968L217.683 94.2557L242.94 98.469L261.699 105.524Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.862 94.912C268.862 97.2396 268.142 99.5101 266.802 101.412C265.462 103.314 263.567 104.754 261.378 105.534L110.977 159.11C104.616 161.377 97.6732 161.404 91.2941 159.189L16.2282 133.085C15.664 132.89 15.1375 132.599 14.6718 132.225L12.9253 129.039L12.886 128.967V114.653L99.9249 105.977L217.362 94.2557L263.124 89.6945C264.144 89.5916 265.171 89.792 266.077 90.2706C266.983 90.7492 267.728 91.4847 268.219 92.3853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.862 94.912C268.862 97.2396 268.142 99.5101 266.802 101.412C265.462 103.314 263.567 104.754 261.378 105.534L110.977 159.11C104.616 161.377 97.6732 161.404 91.2941 159.189L16.2282 133.085C15.664 132.89 15.1375 132.599 14.6718 132.225L12.9253 129.039L12.886 128.967V114.653L99.9249 105.977L217.362 94.2557L263.124 89.6945C264.144 89.5916 265.171 89.792 266.077 90.2706C266.983 90.7492 267.728 91.4847 268.219 92.3853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.534 92.3951C267.978 93.9796 267.075 95.4194 265.891 96.6089C264.707 97.7985 263.273 98.7076 261.692 99.2697L111.292 152.849C104.93 155.115 97.9874 155.141 91.6086 152.924L16.5559 126.83C15.9918 126.637 15.4653 126.347 14.9994 125.974L13.2529 122.784L13.2136 122.712V114.653L100.253 105.977L217.683 94.2557L263.445 89.6945C264.465 89.5916 265.492 89.792 266.398 90.2706C267.304 90.7492 268.05 91.4847 268.541 92.3853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.971 90.0817L111.311 145.374C104.95 147.641 98.0066 147.668 91.6281 145.449L16.5556 119.355C11.7979 117.715 12.2304 110.824 17.1618 109.78L175.79 74.636C177.777 74.1945 179.832 74.1588 181.832 74.531L261.912 88.7101C262.528 88.8184 266.564 89.8684 265.971 90.0817Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.974 60.9788C174.974 60.9788 168.227 68.9887 165.75 71.6139C162.385 75.1808 152.919 71.6139 152.919 71.6139L156.762 79.4565L160.56 79.9848L173.791 70.4686L174.974 60.9788Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M40.754 68.8312C46.8192 62.3996 55.8465 59.3971 61.8625 52.9195C70.0248 44.1319 71.0668 30.8388 77.5547 20.7616C82.142 13.654 89.2557 8.4595 96.9855 5.05338C110.51 -0.841214 125.716 -1.60062 139.76 2.91717C146.241 5.03369 152.437 8.26918 159.2 9.10266C170.941 10.5465 184.038 4.79415 194.074 11.0715C200.955 15.3702 203.544 23.9085 206.159 31.6001C209.655 41.8808 214.953 47.0655 220.101 62.1174C222.49 69.1068 230.455 73.9075 230.177 81.2875C230.101 83.322 229.466 85.4286 227.968 86.8003C226.766 87.9028 225.154 88.4147 223.597 88.8905C169.742 105.282 113.607 112.907 57.3374 111.473C46.2294 111.188 39.5515 109.357 36.3928 98.6593C33.3323 88.2999 32.7687 77.294 40.754 68.8312Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.078 69.4415L150.737 68.5162H152.333V67.85H153.666V67.2003L155.921 67.8993L159.276 68.7131L160.167 68.3226L170.656 70.8361L170.495 71.4498L159.826 76.0142L155.262 75.2628L151.078 69.4415Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.989 64.2602C102.858 64.2489 102.726 64.2704 102.605 64.3225C102.33 64.4767 102.36 64.9099 102.566 65.1494C102.8 65.3619 103.071 65.5298 103.366 65.6449C103.427 65.6697 103.482 65.7067 103.528 65.7535C103.574 65.8003 103.61 65.856 103.634 65.9173C103.651 66.0089 103.637 66.1033 103.595 66.1864C103.313 66.8689 102.491 67.1085 101.783 67.3119C100.71 67.6222 99.6705 68.0388 98.68 68.5556C98.5578 68.6014 98.4572 68.6916 98.3982 68.8082C98.2999 69.1036 98.7259 69.2873 99.0273 69.307C99.7788 69.3628 100.533 69.3628 101.285 69.307C101.088 69.4448 100.862 69.6351 100.915 69.8812C100.967 70.1274 101.197 70.193 101.406 70.2094C101.618 70.2007 101.83 70.2239 102.035 70.2783C102.363 70.4128 102.514 70.8197 102.815 71.0232C103.116 71.1856 103.465 71.2334 103.798 71.1577C104.435 71.0823 105.063 70.945 105.672 70.7475C106.031 70.6509 106.366 70.4811 106.655 70.2488C106.979 69.9089 107.205 69.4885 107.311 69.0314C107.619 68.0469 108.015 66.0781 107.157 65.2348C106.298 64.3914 104.103 64.2897 102.989 64.2602Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0621 64.9558L92.3757 76.8116C92.3757 76.8116 94.7251 81.0479 97.4906 80.4737C100.256 79.8994 102.845 76.431 102.845 76.431L106.518 80.2112C106.518 80.2112 100.735 89.9898 94.4171 89.1334C90.9012 88.6575 83.3647 81.3334 83.3647 81.3334L85.0621 64.9558Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0621 64.9558L92.3757 76.8116C92.3757 76.8116 94.7251 81.0479 97.4906 80.4737C100.256 79.8994 102.845 76.431 102.845 76.431L106.518 80.2112C106.518 80.2112 100.735 89.9898 94.4171 89.1334C90.9012 88.6575 83.3647 81.3334 83.3647 81.3334L85.0621 64.9558Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6899 108.533L167.022 79.1841L248.304 94.6199L118.953 139.848L22.6899 108.533Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M100.826 117.37C102.32 122.371 107.838 125.803 112.976 124.917C116.417 124.33 119.33 122.138 122.341 120.366C129.77 116.02 138.332 114.009 146.916 114.594C152.038 114.958 157.487 116.192 162.1 113.938C165.298 112.372 167.536 109.344 170.495 107.375C172.999 105.701 175.931 104.819 178.641 103.516C182.862 101.488 187.655 96.1622 194.438 91.2072C198.442 88.2835 205.399 85.5796 207.243 83.5221C203.446 82.4885 200.012 86.8626 194.438 87.4598C182.783 88.6772 167.399 87.9258 159.237 88.9791C149.502 90.2326 139.757 91.4894 130.139 93.4451C109.598 97.6191 89.551 103.076 68.8652 106.597C64.7562 107.299 54.1463 107.91 51.5872 112.002C47.7731 118.121 59.8608 120.986 63.7667 121.465C66.8959 121.839 101.694 120.274 100.826 117.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.822 101.406C144.822 101.406 140.428 101.563 139.619 102.666C138.809 103.769 140.441 104.678 140.441 104.678L149.219 101.094L144.822 101.406Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.569 97.1893L126.981 93.0973L126.745 85.4976C126.745 85.4976 118.088 88.7494 117.943 89.1859C117.799 89.6223 119.569 97.1893 119.569 97.1893Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5682 89.1301C82.5682 89.1301 109.719 96.6117 114.742 99.0104C119.765 101.409 120.879 101.636 120.879 101.636L118.953 107.237L66.7156 101.855L82.5682 89.1301Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5682 89.1301C82.5682 89.1301 109.719 96.6117 114.742 99.0104C119.765 101.409 120.879 101.636 120.879 101.636L118.953 107.237L66.7156 101.855L82.5682 89.1301Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.709 105.019L109.525 102.449L103.998 95.3287L81.6079 102.449L82.604 103.946L118.952 107.221L119.709 105.019Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5329 120.274L67.9605 126.538C68.1015 126.588 68.2553 126.588 68.3963 126.538L68.5503 126.479C68.6767 126.43 68.7849 126.343 68.8599 126.23C68.9349 126.117 68.9731 125.984 68.9692 125.848C68.9652 125.712 68.9193 125.581 68.8379 125.473C68.7564 125.364 68.6433 125.284 68.5143 125.242L48.9327 119.04C48.795 118.991 48.6444 118.991 48.5067 119.04C48.3811 119.089 48.2735 119.175 48.1986 119.287C48.1236 119.399 48.0849 119.532 48.0878 119.666C48.0907 119.801 48.1349 119.932 48.2146 120.041C48.2942 120.149 48.4054 120.231 48.5329 120.274Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.698 82.6558L223.168 87.3876C223.8 87.5119 224.454 87.4504 225.052 87.2104L227.018 86.4327C227.174 86.3728 227.306 86.2635 227.394 86.1213C227.482 85.9792 227.521 85.8121 227.505 85.6457C227.489 85.4793 227.419 85.3227 227.305 85.1999C227.192 85.0772 227.042 84.995 226.877 84.9659L203.328 80.559C202.618 80.4248 201.887 80.4734 201.201 80.7001L198.635 81.5401C198.514 81.5793 198.409 81.6577 198.337 81.763C198.265 81.8683 198.229 81.9945 198.236 82.122C198.244 82.2495 198.293 82.3711 198.376 82.4677C198.46 82.5643 198.573 82.6304 198.698 82.6558Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.698 82.6558L223.168 87.3876C223.8 87.5119 224.454 87.4504 225.052 87.2104L227.018 86.4327C227.174 86.3728 227.306 86.2635 227.394 86.1213C227.482 85.9792 227.521 85.8121 227.505 85.6457C227.489 85.4793 227.419 85.3227 227.305 85.1999C227.192 85.0772 227.042 84.995 226.877 84.9659L203.328 80.559C202.618 80.4248 201.887 80.4734 201.201 80.7001L198.635 81.5401C198.514 81.5793 198.409 81.6577 198.337 81.763C198.265 81.8683 198.229 81.9945 198.236 82.122C198.244 82.2495 198.293 82.3711 198.376 82.4677C198.46 82.5643 198.573 82.6304 198.698 82.6558Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.698 81.5927L223.168 86.3278C223.8 86.4488 224.454 86.3873 225.052 86.1506L227.018 85.3729C227.174 85.313 227.306 85.2036 227.394 85.0615C227.482 84.9193 227.521 84.7522 227.505 84.5858C227.489 84.4194 227.419 84.2628 227.305 84.1401C227.192 84.0173 227.042 83.9351 226.877 83.9061L203.328 79.4893C202.618 79.3558 201.887 79.4032 201.201 79.6271L198.629 80.4737C198.506 80.5124 198.4 80.5912 198.327 80.6975C198.254 80.8037 198.218 80.9314 198.226 81.0602C198.234 81.1889 198.285 81.3113 198.37 81.4078C198.456 81.5043 198.571 81.5694 198.698 81.5927Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.407 59.8204C110.407 59.8204 111.014 58.8688 112.662 58.9607C114.31 59.0525 117.338 59.8466 117.338 59.8466L106.852 82.1997H101.75C101.542 82.1998 101.337 82.1471 101.155 82.0466C100.972 81.9461 100.818 81.8011 100.707 81.6249C100.595 81.4488 100.53 81.2472 100.517 81.0391C100.504 80.8309 100.544 80.6229 100.633 80.4343L110.407 59.8204Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.407 59.8204C110.407 59.8204 111.014 58.8688 112.662 58.9607C114.31 59.0525 117.338 59.8466 117.338 59.8466L106.852 82.1997H101.75C101.542 82.1998 101.337 82.1471 101.155 82.0466C100.972 81.9461 100.818 81.8011 100.707 81.6249C100.595 81.4488 100.53 81.2472 100.517 81.0391C100.504 80.8309 100.544 80.6229 100.633 80.4343L110.407 59.8204Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.505 59.8204C111.505 59.8204 112.114 58.8688 113.762 58.9607C114.866 59.0647 115.962 59.249 117.039 59.5119C117.207 59.55 117.363 59.6252 117.498 59.7321C117.633 59.8389 117.741 59.9747 117.817 60.1294C117.892 60.284 117.931 60.4536 117.932 60.6256C117.933 60.7976 117.896 60.9676 117.822 61.1231L108.369 81.3137C108.245 81.5787 108.048 81.8028 107.801 81.9597C107.555 82.1167 107.269 82.1999 106.976 82.1997H102.844C102.636 82.2001 102.431 82.1476 102.249 82.0471C102.066 81.9466 101.912 81.8014 101.801 81.625C101.689 81.4487 101.625 81.247 101.612 81.0388C101.6 80.8305 101.641 80.6226 101.73 80.4343L111.505 59.8204Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.505 59.8204C111.505 59.8204 112.114 58.8688 113.762 58.9607C114.866 59.0647 115.962 59.249 117.039 59.5119C117.207 59.55 117.363 59.6252 117.498 59.7321C117.633 59.8389 117.741 59.9747 117.817 60.1294C117.892 60.284 117.931 60.4536 117.932 60.6256C117.933 60.7976 117.896 60.9676 117.822 61.1231L108.369 81.3137C108.245 81.5787 108.048 81.8028 107.801 81.9597C107.555 82.1167 107.269 82.1999 106.976 82.1997H102.844C102.636 82.2001 102.431 82.1476 102.249 82.0471C102.066 81.9466 101.912 81.8014 101.801 81.625C101.689 81.4487 101.625 81.247 101.612 81.0388C101.6 80.8305 101.641 80.6226 101.73 80.4343L111.505 59.8204Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3892 101.695C59.3892 101.695 54.7494 87.8701 67.581 70.8165C72.4174 64.3849 76.2839 61.1396 79.2231 59.5907C82.4441 57.8942 86.2549 60.5259 85.8781 64.1519C85.013 72.4769 83.3845 88.1982 83.3845 88.3262C83.3845 88.4541 63.9701 104.359 59.3892 101.695Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5798 68.7229C74.5798 68.7229 64.4417 85.7567 66.7649 96.9431C66.7649 96.9431 84.3313 89.9963 83.3712 88.3163C82.4111 86.6362 82.5815 68.713 82.5815 68.713L74.5798 68.7229Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.589 109.606C110.938 110.456 109.172 111.059 107.346 111.395C106.78 111.5 106.209 111.578 105.639 111.631C101.154 108.188 96.9494 104.393 93.0666 100.28C84.9338 106.016 75.4216 111.04 65.5423 109.924C64.3169 109.84 63.1232 109.496 62.0395 108.917C61.3262 108.461 60.6948 107.887 60.1718 107.221C59.3297 106.18 58.6645 104.924 58.5924 103.841C58.4384 101.544 60.3586 100.782 62.2394 99.7455C71.2689 94.7704 80.7277 90.6202 90.5009 87.345C92.6504 86.6231 95.0228 85.9471 97.1428 86.7576C99.2628 87.5681 100.567 89.6288 101.73 91.5682L112.589 109.606Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.589 109.606C110.938 110.456 109.172 111.059 107.346 111.395C106.78 111.5 106.209 111.578 105.639 111.631C101.154 108.188 96.9494 104.393 93.0666 100.28C84.9338 106.016 75.4216 111.04 65.5423 109.924C64.3169 109.84 63.1232 109.496 62.0395 108.917C61.3262 108.461 60.6948 107.887 60.1718 107.221C59.3297 106.18 58.6645 104.924 58.5924 103.841C58.4384 101.544 60.3586 100.782 62.2394 99.7455C71.2689 94.7704 80.7277 90.6202 90.5009 87.345C92.6504 86.6231 95.0228 85.9471 97.1428 86.7576C99.2628 87.5681 100.567 89.6288 101.73 91.5682L112.589 109.606Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5796 68.7229C74.5796 68.7229 79.7961 84.5065 82.4174 86.646C85.0388 88.7855 99.7839 75.2234 99.7839 75.2234V69.9731L87.1818 75.4629C87.1818 75.4629 86.51 62.3372 85.2518 61.5234C83.9935 60.7096 76.1491 59.8007 74.5796 68.7229Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5796 68.7229C74.5796 68.7229 79.7961 84.5065 82.4174 86.646C85.0388 88.7855 99.7839 75.2234 99.7839 75.2234V69.9731L87.1818 75.4629C87.1818 75.4629 86.51 62.3372 85.2518 61.5234C83.9935 60.7096 76.1491 59.8007 74.5796 68.7229Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.327 68.923C101.8 68.7494 102.294 68.6391 102.795 68.5949C103.873 68.4571 104.299 68.1716 105.384 68.211C106.58 68.211 105.682 69.074 105.338 69.1954C104.981 69.2848 104.643 69.437 104.339 69.6449C103.831 70.0781 103.887 70.8525 103.808 71.5154C103.692 72.4827 103.205 73.3672 102.451 73.9829C101.697 74.5985 100.734 74.8974 99.7645 74.8165C99.6345 74.8192 99.5055 74.7932 99.3866 74.7405C99.2677 74.6878 99.1618 74.6095 99.0764 74.5113C98.9886 74.3519 98.9466 74.1713 98.9552 73.9895C98.9126 73.0773 98.5751 71.7221 99.06 70.905C99.391 70.3308 100.607 68.923 101.327 68.923Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7296 46.2648C81.0411 46.7988 80.5742 47.5691 80.419 48.4272C80.2686 49.2756 80.1886 50.135 80.1798 50.9966C80.103 52.2528 79.9122 53.4995 79.6096 54.721C79.7001 54.6424 79.8177 54.6024 79.9373 54.6095C79.987 54.9516 80.0023 55.2979 79.9832 55.6431L80.5238 55.5545C80.5238 56.4011 80.4911 57.2477 80.4255 58.0943C81.7722 57.3987 82.7913 56.2174 83.7776 55.0656C83.8373 55.0024 83.887 54.9305 83.925 54.8523C83.9621 54.7244 83.97 54.5898 83.948 54.4585C83.8499 53.8539 83.9523 53.2338 84.2396 52.6931C84.5673 52.1812 85.2816 51.8793 85.8059 52.1779C86.4776 52.5618 86.4219 53.5233 86.6152 54.2715C86.9458 53.6091 87.185 52.9048 87.3263 52.1779C87.3562 51.9056 87.4409 51.6421 87.5753 51.4035C87.7282 51.2138 87.922 51.0612 88.1421 50.9572C89.4472 50.2612 90.9556 50.0486 92.4019 50.3567C93.2046 50.5339 94.014 50.8719 94.8233 50.7177C95.0021 50.6609 95.1911 50.6441 95.3771 50.6685C95.7048 50.7472 95.9472 51.1541 96.2749 51.0754C96.362 51.0399 96.4404 50.9861 96.5048 50.9175C96.5693 50.849 96.6183 50.7674 96.6485 50.6783C96.9902 49.9311 97.129 49.1067 97.0508 48.2885C96.9725 47.4704 96.68 46.6874 96.2028 46.0187C96.7512 46.1629 97.3139 46.2455 97.8805 46.2648C95.6065 43.1048 91.5073 41.3197 87.6736 41.976C86.8191 42.0859 86.0057 42.4085 85.3078 42.9145C84.9304 43.226 84.6198 43.6107 84.3946 44.0455C84.1694 44.4802 84.0342 44.9561 83.9971 45.4444C83.925 46.1565 83.7972 45.9465 83.1878 45.8841C82.6722 45.8359 82.1561 45.9706 81.7296 46.2648Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7573 53.5135C84.7573 53.7465 84.8163 53.9762 84.8294 54.2092C84.8524 54.6193 84.7442 55.0754 84.9769 55.4167C85.1257 55.5969 85.3172 55.7368 85.5339 55.8236C85.5968 55.8651 85.672 55.8836 85.7469 55.8761C85.7942 55.8599 85.8365 55.8317 85.8698 55.7944C85.9031 55.757 85.9262 55.7117 85.937 55.6628C86.0298 55.3413 86.0298 55 85.937 54.6784C85.8485 54.3675 85.7828 54.0505 85.7404 53.7301C85.7207 53.4971 85.7797 53.1591 85.6158 52.9589C85.2292 52.493 84.7541 53.1033 84.7573 53.5135Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.235 68.9493C112.009 68.6966 111.665 68.4275 111.374 68.5949C111.082 68.7622 111.157 69.2512 111.295 69.5793C111.433 69.9075 111.6 70.3176 111.754 70.6852C111.589 70.3838 111.38 70.1084 111.134 69.8681C111.061 69.7822 110.96 69.7234 110.849 69.7007C110.763 69.703 110.68 69.7349 110.615 69.7911C110.549 69.8472 110.505 69.9242 110.489 70.0092C110.465 70.1813 110.481 70.3568 110.538 70.5211L110.912 71.9649C110.704 71.655 110.424 71.4005 110.096 71.2233C110.05 71.1878 109.995 71.1651 109.938 71.1576C109.88 71.1501 109.822 71.1581 109.768 71.1807C109.64 71.2594 109.65 71.4465 109.683 71.5941C109.838 72.2902 110.072 72.9662 110.381 73.6089C110.201 73.4219 109.938 73.2184 109.725 73.3431C109.512 73.4678 109.555 73.878 109.68 74.1471L110.4 75.7221C110.455 75.8973 110.572 76.0465 110.728 76.1422C111.056 76.2701 111.351 75.9256 111.521 75.627C112.071 74.6559 112.55 73.6458 112.953 72.6048C113.182 72.0207 113.487 71.2561 113.33 70.6359C113.173 70.0157 112.642 69.412 112.235 68.9493Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.28 106.272H121.908L123.268 102.449L120.879 101.619L119.28 106.272Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.249 95.4895C127.515 95.0591 127.865 94.6873 128.278 94.3967C128.486 94.255 128.73 94.1747 128.981 94.1648C129.233 94.1549 129.482 94.216 129.7 94.341C129.874 94.4867 130.017 94.6657 130.12 94.8674C130.224 95.0691 130.286 95.2896 130.303 95.5157C130.503 96.7725 130.241 98.0523 129.959 99.2926C129.361 101.946 128.679 104.579 127.915 107.191C127.906 107.294 127.874 107.394 127.822 107.483C127.77 107.572 127.699 107.648 127.613 107.706C127.527 107.763 127.43 107.801 127.328 107.816C127.226 107.831 127.122 107.822 127.023 107.792C125.491 107.696 123.978 107.401 122.521 106.915C122.304 106.869 122.11 106.747 121.974 106.571C121.921 106.435 121.899 106.289 121.909 106.144C121.919 105.999 121.962 105.858 122.033 105.731C123.452 102.088 124.959 98.6987 127.249 95.4895Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.747 111.316L109.778 113.114L113.799 111.631L112.586 109.606L107.747 111.316Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.778 113.117L111.996 117.554L123.704 114.217C123.704 114.217 124.317 112.189 121.594 111.979C118.871 111.769 113.798 111.647 113.798 111.647L109.778 113.117Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.923 110.686L107.353 111.395C106.786 111.5 106.216 111.578 105.646 111.631C101.16 108.188 96.956 104.393 93.0732 100.28C84.9405 106.016 75.4282 111.04 65.549 109.924C64.3235 109.84 63.1299 109.496 62.0462 108.917C61.3329 108.461 60.7015 107.887 60.1785 107.221C62.2231 108.425 65.6145 107.221 65.6145 107.221C65.6145 107.221 92.2442 93.4386 93.7941 93.1695C95.344 92.9004 108.923 110.686 108.923 110.686Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.094 90.8134C183.094 90.8134 178.15 94.3344 170.495 92.4148C162.841 90.4951 159.004 89.1334 159.004 89.1334L150.599 99.4337L150.557 99.483L149.538 99.0925L146.238 97.8357C146.238 97.8357 149.901 84.5918 152.071 82.2325C152.726 81.527 155.21 78.4195 159.102 79.4269C163.611 80.5951 172.602 81.8978 178.792 83.2727C184.323 84.4967 183.094 90.8134 183.094 90.8134Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.094 90.8134C183.094 90.8134 178.15 94.3344 170.495 92.4148C162.841 90.4951 159.004 89.1334 159.004 89.1334L150.599 99.4337L150.557 99.483L149.538 99.0925L146.238 97.8357C146.238 97.8357 149.901 84.5918 152.071 82.2325C152.726 81.527 155.21 78.4195 159.102 79.4269C163.611 80.5951 172.602 81.8978 178.792 83.2727C184.323 84.4967 183.094 90.8134 183.094 90.8134Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.301 87.2597L170.495 92.4148C162.841 90.4952 159.004 89.1334 159.004 89.1334L150.599 99.4338L149.537 99.1056L158.165 84.6674L171.301 87.2597Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.792 83.2695L141.378 103.503C141.378 103.503 143.724 105.376 144.249 106.272C144.773 107.168 147.148 107.798 147.148 107.798C147.148 107.798 169.328 100.907 171.645 98.8563C171.645 98.8563 177.215 98.2 179.837 97.757C182.458 97.314 185.381 94.5773 186.846 90.8135C188.31 87.0497 187.707 82.692 187.707 82.692L178.805 83.2695H178.792Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.792 83.2695L141.378 103.503C141.378 103.503 143.724 105.376 144.249 106.272C144.773 107.168 147.148 107.798 147.148 107.798C147.148 107.798 169.328 100.907 171.645 98.8563C171.645 98.8563 177.215 98.2 179.837 97.757C182.458 97.314 185.381 94.5773 186.846 90.8135C188.31 87.0497 187.707 82.692 187.707 82.692L178.805 83.2695H178.792Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.919 103.946L138.911 105.432L142.62 109.107L145.956 107.394L141.919 103.946Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.606 105.432C139.606 105.432 135.461 99.7783 134.098 100.33C132.735 100.881 132.319 103.283 132.423 103.611C132.502 103.847 136.133 108.914 137.928 111.411C138.195 111.783 138.593 112.039 139.041 112.128C139.49 112.217 139.955 112.132 140.343 111.89L142.283 110.689L143.151 108.842L139.606 105.432Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.575 97.9604L145.563 101.239L149.537 99.0892L146.575 97.9604Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.272 84.0833L171.871 81.8913C171.871 81.8913 177.389 76.2472 173.66 71.6204C173.66 71.6204 171.222 69.7106 171.655 67.4563C171.93 66.0289 173.716 63.0034 174.984 60.9788C175.378 60.3508 175.896 59.8108 176.507 59.3924C177.118 58.9741 177.809 58.6864 178.536 58.5472L186.289 57.0607C186.289 57.0607 189.444 57.4447 190.699 61.4283C191.954 65.412 187.688 82.6919 187.688 82.6919L176.272 84.0833Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.272 84.0833L171.871 81.8913C171.871 81.8913 177.389 76.2472 173.66 71.6204C173.66 71.6204 171.222 69.7106 171.655 67.4563C171.93 66.0289 173.716 63.0034 174.984 60.9788C175.378 60.3508 175.896 59.8108 176.507 59.3924C177.118 58.9741 177.809 58.6864 178.536 58.5472L186.289 57.0607C186.289 57.0607 189.444 57.4447 190.699 61.4283C191.954 65.412 187.688 82.6919 187.688 82.6919L176.272 84.0833Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.305 57.0705C186.305 57.0705 180.564 63.2757 178.536 62.0583C178.269 61.9247 178.044 61.7209 177.885 61.4688C177.726 61.2167 177.638 60.9259 177.632 60.6276C177.632 59.5841 178.536 58.557 178.536 58.557C178.536 58.557 180.023 55.5578 177.435 55.9877H177.389C174.738 56.4569 173.844 50.0122 174.941 45.9727C176.039 41.9333 183.025 45.0638 183.215 46.4518C183.405 47.8399 186.305 57.0705 186.305 57.0705Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.96 42.8357C177.717 43.1147 178.11 43.9219 178.53 44.611C179.594 46.3682 181.194 47.7361 183.094 48.5126C183.949 48.8604 184.946 49.0737 185.771 48.6603C185.263 47.7367 184.94 46.7222 184.821 45.6742C184.792 45.0673 184.72 44.4632 184.608 43.8661C184.162 42.1106 182.504 40.9424 180.846 40.227C179.929 39.7931 178.931 39.5561 177.917 39.5313C177.41 39.5221 176.907 39.6219 176.442 39.824C175.977 40.0261 175.56 40.3258 175.22 40.7028C174.835 41.1991 174.584 41.787 174.493 42.4092C174.382 43.0654 174.201 44.5421 174.975 43.8727C175.62 43.3083 175.804 42.4092 176.96 42.8357Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.412 50.6127C182.714 50.2452 183.032 49.8941 183.363 49.5528C183.487 49.4248 183.667 49.2903 183.825 49.3723C183.888 49.4138 183.937 49.4733 183.966 49.543C184.082 49.7699 184.146 50.0206 184.151 50.2759C184.156 50.5312 184.103 50.7842 183.995 51.0158C183.888 51.2473 183.729 51.4511 183.531 51.6116C183.332 51.7721 183.1 51.885 182.851 51.9417C183.599 52.0795 181.691 55.6169 184.719 57.9598C187.55 60.1485 189.221 58.2059 189.798 58.2486C189.89 56.8671 186.151 51.4528 186.099 50.068C186.116 49.6391 186.026 49.2128 185.837 48.8276C185.456 48.1713 184.133 47.3411 183.415 47.9055C182.773 48.401 182.625 49.8875 182.412 50.6127Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.768 60.329C190.581 60.0033 190.314 59.7313 189.992 59.5396C189.669 59.3478 189.303 59.2427 188.928 59.2344C188.553 59.2262 188.183 59.3151 187.852 59.4925C187.522 59.6699 187.243 59.9298 187.042 60.247C186.648 60.817 186.378 61.4632 186.248 62.1442C186.118 62.8252 186.132 63.5258 186.289 64.2011C187.141 67.6663 194.48 75.4137 194.48 75.4137L200.051 85.4975C200.051 85.4975 198.675 88.8938 200.87 86.2588C201.955 84.9627 204.52 84.7559 205.932 84.7461C206.265 84.7469 206.585 84.6213 206.828 84.3947C207.072 84.168 207.22 83.8573 207.243 83.5254C207.243 83.3285 207.204 83.1972 207.053 83.1972C206.545 83.2497 203.495 82.8921 203.495 82.8921L200.772 83.5287C200.772 83.5287 197.193 73.5236 197.023 73.3399C196.853 73.1561 193.609 65.2544 190.768 60.329Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.737 69.4415L155.462 76.0044L161.93 76.7985C161.93 76.7985 167.074 73.6516 168.113 73.1135C169.152 72.5753 171.301 71.6073 171.301 71.6073L161.019 69.4284L156.281 74.8034L155.262 75.2497L151.074 69.4284L150.737 69.4415Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.737 69.4415L155.462 76.0044L161.93 76.7985C161.93 76.7985 167.074 73.6516 168.113 73.1135C169.152 72.5753 171.301 71.6073 171.301 71.6073L161.019 69.4284L156.281 74.8034L155.262 75.2497L151.074 69.4284L150.737 69.4415Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.333 67.85L155.629 74.2422L155.835 74.7115L156.281 74.8132L153.666 67.85H152.333Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.737 68.5162L155.462 75.0003H155.783L152.333 68.5162H150.737Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.666 67.2003L156.281 73.8747L159.275 68.7131L153.666 67.2003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.333 67.85L155.629 74.2422L155.835 74.7115L156.281 74.8132L153.666 67.85H152.333Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.737 68.5162L155.462 75.0003H155.783L152.333 68.5162H150.737Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.666 67.2003L156.281 73.8747L159.275 68.7131L153.666 67.2003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.249 106.272C144.249 106.272 163.499 99.3812 171.321 96.0014C172.806 95.3547 174.362 94.8866 175.957 94.6068C177.881 94.2786 180.6 93.6223 182.412 92.3885C185.473 90.3015 187.695 86.0751 187.695 86.0751C187.695 86.0751 187.776 95.5715 179.83 97.7569L171.639 98.8562C171.639 98.8562 168.781 100.523 163.575 102.338C158.368 104.152 147.142 107.798 147.142 107.798C147.142 107.798 144.92 107.066 144.766 106.909C144.612 106.751 144.249 106.272 144.249 106.272Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.631 60.6277C177.631 59.5842 178.536 58.5571 178.536 58.5571C178.536 58.5571 180.023 55.5578 177.435 55.9877C181.645 55.2953 181.134 52.5258 182.127 55.0427C183.792 59.2626 177.831 60.6014 177.631 60.6277Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.935 45.7431C171.178 44.9391 171.781 44.2861 172.043 43.4887C172.259 42.8325 172.233 42.1237 172.407 41.4575C172.722 40.3951 173.437 39.4971 174.402 38.9538C175.364 38.4221 176.434 38.1169 177.531 38.0613C179.876 37.8739 182.215 38.4881 184.167 39.8037C186.112 41.1365 187.471 43.1682 187.961 45.4773C188.056 46.2063 188.206 46.9271 188.41 47.6332C188.662 48.3223 189.17 48.9753 189.881 49.1525L189.812 49.9728C190.459 50.1033 191.053 50.422 191.519 50.889C191.985 51.356 192.304 51.9506 192.434 52.598C192.637 53.6907 192.277 54.8589 192.624 55.9155C192.952 56.8999 193.81 57.6415 193.935 58.6522C193.965 59.2754 193.841 59.8965 193.574 60.4603C193.065 61.786 192.512 63.092 191.916 64.3783C191.002 63.3939 190.048 62.4095 188.816 61.8779C188.076 61.5497 187.27 61.4382 186.523 61.1789C182.46 59.7876 180.549 54.9639 176.742 52.9754C175.887 52.5258 174.795 52.3781 173.989 51.8695C173.383 51.4856 173.367 50.9606 173.006 50.3962C172.027 48.8867 170.31 47.8399 170.935 45.7431Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.245 55.1247C173.481 56.2239 174.264 57.1198 175.087 57.8876C175.513 58.2847 175.981 58.6948 176.122 59.2625C176.147 59.4498 176.202 59.6317 176.286 59.8007C176.519 60.1288 177.04 60.0829 177.41 59.9057C177.851 59.6765 178.235 59.3511 178.533 58.9535C178.831 58.556 179.036 58.0964 179.134 57.6087C179.321 56.6309 179.207 55.619 178.806 54.7079C178.46 53.8663 177.939 53.1077 177.279 52.4821C176.619 51.8566 175.834 51.3782 174.976 51.0787C172.964 50.4782 172.983 53.8941 173.245 55.1247Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2961 59.8663L84.3193 48.5881C84.3193 48.5881 89.7619 45.9629 93.5268 48.2304C97.2918 50.4979 94.1035 58.1305 93.5268 60.5423C92.9501 62.9542 89.2376 63.8959 87.8254 62.7934C86.4131 61.6908 84.5651 64.9558 84.5651 64.9558L79.2961 59.8663Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.474 60.9788C174.474 60.9788 167.727 68.9887 165.25 71.6139C161.885 75.1808 152.419 71.6139 152.419 71.6139L156.262 79.4565L160.06 79.9848L173.291 70.4686L174.474 60.9788Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.578 69.4415L150.237 68.5162H151.833V67.85H153.166V67.2003L155.421 67.8993L158.776 68.7131L159.667 68.3226L170.156 70.8361L169.995 71.4498L159.326 76.0142L154.762 75.2628L150.578 69.4415Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5621 64.9558L91.8757 76.8116C91.8757 76.8116 94.2251 81.0479 96.9906 80.4737C99.7561 79.8994 102.345 76.431 102.345 76.431L106.018 80.2112C106.018 80.2112 100.235 89.9898 93.9171 89.1334C90.4012 88.6575 82.8647 81.3334 82.8647 81.3334L84.5621 64.9558Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5621 64.9558L91.8757 76.8116C91.8757 76.8116 94.2251 81.0479 96.9906 80.4737C99.7561 79.8994 102.345 76.431 102.345 76.431L106.018 80.2112C106.018 80.2112 100.235 89.9898 93.9171 89.1334C90.4012 88.6575 82.8647 81.3334 82.8647 81.3334L84.5621 64.9558Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M100.326 117.37C101.82 122.371 107.338 125.803 112.476 124.917C115.917 124.33 118.83 122.138 121.841 120.366C129.27 116.02 137.832 114.009 146.416 114.594C151.538 114.958 156.987 116.192 161.6 113.938C164.798 112.372 167.036 109.344 169.995 107.375C172.499 105.701 175.431 104.819 178.141 103.516C182.362 101.488 187.155 96.1622 193.938 91.2072C197.942 88.2835 204.899 85.5796 206.743 83.5221C202.946 82.4885 199.512 86.8626 193.938 87.4598C182.283 88.6772 166.899 87.9258 158.737 88.9791C149.002 90.2326 139.257 91.4894 129.639 93.4451C109.098 97.6191 89.051 103.076 68.3652 106.597C64.2562 107.299 53.6463 107.91 51.0872 112.002C47.2731 118.121 59.3608 120.986 63.2667 121.465C66.3959 121.839 101.194 120.274 100.326 117.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.322 101.406C144.322 101.406 139.928 101.563 139.119 102.666C138.309 103.769 139.941 104.678 139.941 104.678L148.719 101.094L144.322 101.406Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.069 97.1893L126.481 93.0973L126.245 85.4976C126.245 85.4976 117.588 88.7494 117.443 89.1859C117.299 89.6223 119.069 97.1893 119.069 97.1893Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0682 89.1301C82.0682 89.1301 109.219 96.6117 114.242 99.0104C119.265 101.409 120.379 101.636 120.379 101.636L118.453 107.237L66.2156 101.855L82.0682 89.1301Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0682 89.1301C82.0682 89.1301 109.219 96.6117 114.242 99.0104C119.265 101.409 120.379 101.636 120.379 101.636L118.453 107.237L66.2156 101.855L82.0682 89.1301Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.209 105.019L109.025 102.449L103.498 95.3287L81.1079 102.449L82.104 103.946L118.452 107.221L119.209 105.019Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.907 59.8204C109.907 59.8204 110.514 58.8688 112.162 58.9607C113.81 59.0525 116.838 59.8466 116.838 59.8466L106.352 82.1997H101.25C101.042 82.1998 100.837 82.1471 100.655 82.0466C100.472 81.9461 100.318 81.8011 100.207 81.6249C100.095 81.4488 100.03 81.2472 100.017 81.0391C100.004 80.8309 100.044 80.6229 100.133 80.4343L109.907 59.8204Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.907 59.8204C109.907 59.8204 110.514 58.8688 112.162 58.9607C113.81 59.0525 116.838 59.8466 116.838 59.8466L106.352 82.1997H101.25C101.042 82.1998 100.837 82.1471 100.655 82.0466C100.472 81.9461 100.318 81.8011 100.207 81.6249C100.095 81.4488 100.03 81.2472 100.017 81.0391C100.004 80.8309 100.044 80.6229 100.133 80.4343L109.907 59.8204Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.005 59.8204C111.005 59.8204 111.614 58.8688 113.262 58.9607C114.366 59.0647 115.462 59.249 116.539 59.5119C116.707 59.55 116.863 59.6252 116.998 59.7321C117.133 59.8389 117.241 59.9747 117.317 60.1294C117.392 60.284 117.431 60.4536 117.432 60.6256C117.433 60.7976 117.396 60.9676 117.322 61.1231L107.869 81.3137C107.745 81.5787 107.548 81.8028 107.301 81.9597C107.055 82.1167 106.769 82.1999 106.476 82.1997H102.344C102.136 82.2001 101.931 82.1476 101.749 82.0471C101.566 81.9466 101.412 81.8014 101.301 81.625C101.189 81.4487 101.125 81.247 101.112 81.0388C101.1 80.8305 101.141 80.6226 101.23 80.4343L111.005 59.8204Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8892 101.695C58.8892 101.695 54.2494 87.8701 67.081 70.8165C71.9174 64.3849 75.7839 61.1396 78.7231 59.5907C81.9441 57.8942 85.7549 60.5259 85.3781 64.1519C84.513 72.4769 82.8845 88.1982 82.8845 88.3262C82.8845 88.4541 63.4701 104.359 58.8892 101.695Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0798 68.7229C74.0798 68.7229 63.9417 85.7567 66.2649 96.9431C66.2649 96.9431 83.8313 89.9963 82.8712 88.3163C81.9111 86.6362 82.0815 68.713 82.0815 68.713L74.0798 68.7229Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.089 109.606C110.438 110.456 108.672 111.059 106.846 111.395C106.28 111.5 105.709 111.578 105.139 111.631C100.654 108.188 96.4494 104.393 92.5666 100.28C84.4338 106.016 74.9216 111.04 65.0423 109.924C63.8169 109.84 62.6232 109.496 61.5395 108.917C60.8262 108.461 60.1948 107.887 59.6718 107.221C58.8297 106.18 58.1645 104.924 58.0924 103.841C57.9384 101.544 59.8586 100.782 61.7394 99.7455C70.7689 94.7704 80.2277 90.6202 90.0009 87.345C92.1504 86.6231 94.5228 85.9471 96.6428 86.7576C98.7628 87.5681 100.067 89.6288 101.23 91.5682L112.089 109.606Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.089 109.606C110.438 110.456 108.672 111.059 106.846 111.395C106.28 111.5 105.709 111.578 105.139 111.631C100.654 108.188 96.4494 104.393 92.5666 100.28C84.4338 106.016 74.9216 111.04 65.0423 109.924C63.8169 109.84 62.6232 109.496 61.5395 108.917C60.8262 108.461 60.1948 107.887 59.6718 107.221C58.8297 106.18 58.1645 104.924 58.0924 103.841C57.9384 101.544 59.8586 100.782 61.7394 99.7455C70.7689 94.7704 80.2277 90.6202 90.0009 87.345C92.1504 86.6231 94.5228 85.9471 96.6428 86.7576C98.7628 87.5681 100.067 89.6288 101.23 91.5682L112.089 109.606Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0796 68.7229C74.0796 68.7229 79.2961 84.5065 81.9174 86.646C84.5388 88.7855 99.2839 75.2234 99.2839 75.2234V69.9731L86.6818 75.4629C86.6818 75.4629 86.01 62.3372 84.7518 61.5234C83.4935 60.7096 75.6491 59.8007 74.0796 68.7229Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0796 68.7229C74.0796 68.7229 79.2961 84.5065 81.9174 86.646C84.5388 88.7855 99.2839 75.2234 99.2839 75.2234V69.9731L86.6818 75.4629C86.6818 75.4629 86.01 62.3372 84.7518 61.5234C83.4935 60.7096 75.6491 59.8007 74.0796 68.7229Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.827 68.923C101.3 68.7494 101.794 68.6391 102.295 68.5949C103.373 68.4571 103.799 68.1716 104.884 68.211C106.08 68.211 105.182 69.074 104.838 69.1954C104.481 69.2848 104.143 69.437 103.839 69.6449C103.331 70.0781 103.387 70.8525 103.308 71.5154C103.192 72.4827 102.705 73.3672 101.951 73.9829C101.197 74.5985 100.234 74.8974 99.2645 74.8165C99.1345 74.8192 99.0055 74.7932 98.8866 74.7405C98.7677 74.6878 98.6618 74.6095 98.5764 74.5113C98.4886 74.3519 98.4466 74.1713 98.4552 73.9895C98.4126 73.0773 98.0751 71.7221 98.56 70.905C98.891 70.3308 100.107 68.923 100.827 68.923Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2296 46.2648C80.5411 46.7988 80.0742 47.5691 79.919 48.4272C79.7686 49.2756 79.6886 50.135 79.6798 50.9966C79.603 52.2528 79.4122 53.4995 79.1096 54.721C79.2001 54.6424 79.3177 54.6024 79.4373 54.6095C79.487 54.9516 79.5023 55.2979 79.4832 55.6431L80.0238 55.5545C80.0238 56.4011 79.9911 57.2477 79.9255 58.0943C81.2722 57.3987 82.2913 56.2174 83.2776 55.0656C83.3373 55.0024 83.387 54.9305 83.425 54.8523C83.4621 54.7244 83.47 54.5898 83.448 54.4585C83.3499 53.8539 83.4523 53.2338 83.7396 52.6931C84.0673 52.1812 84.7816 51.8793 85.3059 52.1779C85.9776 52.5618 85.9219 53.5233 86.1152 54.2715C86.4458 53.6091 86.685 52.9048 86.8263 52.1779C86.8562 51.9056 86.9409 51.6421 87.0753 51.4035C87.2282 51.2138 87.422 51.0612 87.6421 50.9572C88.9472 50.2612 90.4556 50.0486 91.9019 50.3567C92.7046 50.5339 93.514 50.8719 94.3233 50.7177C94.5021 50.6609 94.6911 50.6441 94.8771 50.6685C95.2048 50.7472 95.4472 51.1541 95.7749 51.0754C95.862 51.0399 95.9404 50.9861 96.0048 50.9175C96.0693 50.849 96.1183 50.7674 96.1485 50.6783C96.4902 49.9311 96.629 49.1067 96.5508 48.2885C96.4725 47.4704 96.18 46.6874 95.7028 46.0187C96.2512 46.1629 96.8139 46.2455 97.3805 46.2648C95.1065 43.1048 91.0073 41.3197 87.1736 41.976C86.3191 42.0859 85.5057 42.4085 84.8078 42.9145C84.4304 43.226 84.1198 43.6107 83.8946 44.0455C83.6694 44.4802 83.5342 44.9561 83.4971 45.4444C83.425 46.1565 83.2972 45.9465 82.6878 45.8841C82.1722 45.8359 81.6561 45.9706 81.2296 46.2648Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2573 53.5135C84.2573 53.7465 84.3163 53.9762 84.3294 54.2092C84.3524 54.6193 84.2442 55.0754 84.4769 55.4167C84.6257 55.5969 84.8172 55.7368 85.0339 55.8236C85.0968 55.8651 85.172 55.8836 85.2469 55.8761C85.2942 55.8599 85.3365 55.8317 85.3698 55.7944C85.4031 55.757 85.4262 55.7117 85.437 55.6628C85.5298 55.3413 85.5298 55 85.437 54.6784C85.3485 54.3675 85.2828 54.0505 85.2404 53.7301C85.2207 53.4971 85.2797 53.1591 85.1158 52.9589C84.7292 52.493 84.2541 53.1033 84.2573 53.5135Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.735 68.9493C111.509 68.6966 111.165 68.4275 110.874 68.5949C110.582 68.7622 110.657 69.2512 110.795 69.5793C110.933 69.9075 111.1 70.3176 111.254 70.6852C111.089 70.3838 110.88 70.1084 110.634 69.8681C110.561 69.7822 110.46 69.7234 110.349 69.7007C110.263 69.703 110.18 69.7349 110.115 69.7911C110.049 69.8472 110.005 69.9242 109.989 70.0092C109.965 70.1813 109.981 70.3568 110.038 70.5211L110.412 71.9649C110.204 71.655 109.924 71.4005 109.596 71.2233C109.55 71.1878 109.495 71.1651 109.438 71.1576C109.38 71.1501 109.322 71.1581 109.268 71.1807C109.14 71.2594 109.15 71.4465 109.183 71.5941C109.338 72.2902 109.572 72.9662 109.881 73.6089C109.701 73.4219 109.438 73.2184 109.225 73.3431C109.012 73.4678 109.055 73.878 109.18 74.1471L109.9 75.7221C109.955 75.8973 110.072 76.0465 110.228 76.1422C110.556 76.2701 110.851 75.9256 111.021 75.627C111.571 74.6559 112.05 73.6458 112.453 72.6048C112.682 72.0207 112.987 71.2561 112.83 70.6359C112.673 70.0157 112.142 69.412 111.735 68.9493Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.78 106.272H121.408L122.768 102.449L120.379 101.619L118.78 106.272Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.749 95.4895C127.015 95.0591 127.365 94.6873 127.778 94.3967C127.986 94.255 128.23 94.1747 128.481 94.1648C128.733 94.1549 128.982 94.216 129.2 94.341C129.374 94.4867 129.517 94.6657 129.62 94.8674C129.724 95.0691 129.786 95.2896 129.803 95.5157C130.003 96.7725 129.741 98.0523 129.459 99.2926C128.861 101.946 128.179 104.579 127.415 107.191C127.406 107.294 127.374 107.394 127.322 107.483C127.27 107.572 127.199 107.648 127.113 107.706C127.027 107.763 126.93 107.801 126.828 107.816C126.726 107.831 126.622 107.822 126.523 107.792C124.991 107.696 123.478 107.401 122.021 106.915C121.804 106.869 121.61 106.747 121.474 106.571C121.421 106.435 121.399 106.289 121.409 106.144C121.419 105.999 121.462 105.858 121.533 105.731C122.952 102.088 124.459 98.6987 126.749 95.4895Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.247 111.316L109.278 113.114L113.299 111.631L112.086 109.606L107.247 111.316Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.278 113.117L111.496 117.554L123.204 114.217C123.204 114.217 123.817 112.189 121.094 111.979C118.371 111.769 113.298 111.647 113.298 111.647L109.278 113.117Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.423 110.686L106.853 111.395C106.286 111.5 105.716 111.578 105.146 111.631C100.66 108.188 96.456 104.393 92.5732 100.28C84.4405 106.016 74.9282 111.04 65.049 109.924C63.8235 109.84 62.6299 109.496 61.5462 108.917C60.8329 108.461 60.2015 107.887 59.6785 107.221C61.7231 108.425 65.1145 107.221 65.1145 107.221C65.1145 107.221 91.7442 93.4386 93.2941 93.1695C94.844 92.9004 108.423 110.686 108.423 110.686Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.594 90.8134C182.594 90.8134 177.65 94.3344 169.995 92.4148C162.341 90.4951 158.504 89.1334 158.504 89.1334L150.099 99.4337L150.057 99.483L149.038 99.0925L145.738 97.8357C145.738 97.8357 149.401 84.5918 151.571 82.2325C152.226 81.527 154.71 78.4195 158.602 79.4269C163.111 80.5951 172.102 81.8978 178.292 83.2727C183.823 84.4967 182.594 90.8134 182.594 90.8134Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.594 90.8134C182.594 90.8134 177.65 94.3344 169.995 92.4148C162.341 90.4951 158.504 89.1334 158.504 89.1334L150.099 99.4337L150.057 99.483L149.038 99.0925L145.738 97.8357C145.738 97.8357 149.401 84.5918 151.571 82.2325C152.226 81.527 154.71 78.4195 158.602 79.4269C163.111 80.5951 172.102 81.8978 178.292 83.2727C183.823 84.4967 182.594 90.8134 182.594 90.8134Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.801 87.2597L169.995 92.4148C162.341 90.4952 158.504 89.1334 158.504 89.1334L150.099 99.4338L149.037 99.1056L157.665 84.6674L170.801 87.2597Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.292 83.2695L140.878 103.503C140.878 103.503 143.224 105.376 143.749 106.272C144.273 107.168 146.648 107.798 146.648 107.798C146.648 107.798 168.828 100.907 171.145 98.8563C171.145 98.8563 176.715 98.2 179.337 97.757C181.958 97.314 184.881 94.5773 186.346 90.8135C187.81 87.0497 187.207 82.692 187.207 82.692L178.305 83.2695H178.292Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.292 83.2695L140.878 103.503C140.878 103.503 143.224 105.376 143.749 106.272C144.273 107.168 146.648 107.798 146.648 107.798C146.648 107.798 168.828 100.907 171.145 98.8563C171.145 98.8563 176.715 98.2 179.337 97.757C181.958 97.314 184.881 94.5773 186.346 90.8135C187.81 87.0497 187.207 82.692 187.207 82.692L178.305 83.2695H178.292Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.419 103.946L138.411 105.432L142.12 109.107L145.456 107.394L141.419 103.946Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.106 105.432C139.106 105.432 134.961 99.7783 133.598 100.33C132.235 100.881 131.819 103.283 131.923 103.611C132.002 103.847 135.633 108.914 137.428 111.411C137.695 111.783 138.093 112.039 138.541 112.128C138.99 112.217 139.455 112.132 139.843 111.89L141.783 110.689L142.651 108.842L139.106 105.432Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.075 97.9604L145.063 101.239L149.037 99.0892L146.075 97.9604Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.772 84.0833L171.371 81.8913C171.371 81.8913 176.889 76.2472 173.16 71.6204C173.16 71.6204 170.722 69.7106 171.155 67.4563C171.43 66.0289 173.216 63.0034 174.484 60.9788C174.878 60.3508 175.396 59.8108 176.007 59.3924C176.618 58.9741 177.309 58.6864 178.036 58.5472L185.789 57.0607C185.789 57.0607 188.944 57.4447 190.199 61.4283C191.454 65.412 187.188 82.6919 187.188 82.6919L175.772 84.0833Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.805 57.0705C185.805 57.0705 180.064 63.2757 178.036 62.0583C177.769 61.9247 177.544 61.7209 177.385 61.4688C177.226 61.2167 177.138 60.9259 177.132 60.6276C177.132 59.5841 178.036 58.557 178.036 58.557C178.036 58.557 179.523 55.5578 176.935 55.9877H176.889C174.238 56.4569 173.344 50.0122 174.441 45.9727C175.539 41.9333 182.525 45.0638 182.715 46.4518C182.905 47.8399 185.805 57.0705 185.805 57.0705Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.46 42.8357C177.217 43.1147 177.61 43.9219 178.03 44.611C179.094 46.3682 180.694 47.7361 182.594 48.5126C183.449 48.8604 184.446 49.0737 185.271 48.6603C184.763 47.7367 184.44 46.7222 184.321 45.6742C184.292 45.0673 184.22 44.4632 184.108 43.8661C183.662 42.1106 182.004 40.9424 180.346 40.227C179.429 39.7931 178.431 39.5561 177.417 39.5313C176.91 39.5221 176.407 39.6219 175.942 39.824C175.477 40.0261 175.06 40.3258 174.72 40.7028C174.335 41.1991 174.084 41.787 173.993 42.4092C173.882 43.0654 173.701 44.5421 174.475 43.8727C175.12 43.3083 175.304 42.4092 176.46 42.8357Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.912 50.6127C182.214 50.2452 182.532 49.8941 182.863 49.5528C182.987 49.4248 183.167 49.2903 183.325 49.3723C183.388 49.4138 183.437 49.4733 183.466 49.543C183.582 49.7699 183.646 50.0206 183.651 50.2759C183.656 50.5312 183.603 50.7842 183.495 51.0158C183.388 51.2473 183.229 51.4511 183.031 51.6116C182.832 51.7721 182.6 51.885 182.351 51.9417C183.099 52.0795 181.191 55.6169 184.219 57.9598C187.05 60.1485 188.721 58.2059 189.298 58.2486C189.39 56.8671 185.651 51.4528 185.599 50.068C185.616 49.6391 185.526 49.2128 185.337 48.8276C184.956 48.1713 183.633 47.3411 182.915 47.9055C182.273 48.401 182.125 49.8875 181.912 50.6127Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.268 60.329C190.081 60.0033 189.814 59.7313 189.492 59.5396C189.169 59.3478 188.803 59.2427 188.428 59.2344C188.053 59.2262 187.683 59.3151 187.352 59.4925C187.022 59.6699 186.743 59.9298 186.542 60.247C186.148 60.817 185.878 61.4632 185.748 62.1442C185.618 62.8252 185.632 63.5258 185.789 64.2011C186.641 67.6663 193.98 75.4137 193.98 75.4137L199.551 85.4975C199.551 85.4975 198.175 88.8938 200.37 86.2588C201.455 84.9627 204.02 84.7559 205.432 84.7461C205.765 84.7469 206.085 84.6213 206.328 84.3947C206.572 84.168 206.72 83.8573 206.743 83.5254C206.743 83.3285 206.704 83.1972 206.553 83.1972C206.045 83.2497 202.995 82.8921 202.995 82.8921L200.272 83.5287C200.272 83.5287 196.693 73.5236 196.523 73.3399C196.353 73.1561 193.109 65.2544 190.268 60.329Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.237 69.4415L154.962 76.0044L161.43 76.7985C161.43 76.7985 166.574 73.6516 167.613 73.1135C168.652 72.5753 170.801 71.6073 170.801 71.6073L160.519 69.4284L155.781 74.8034L154.762 75.2497L150.574 69.4284L150.237 69.4415Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.237 69.4415L154.962 76.0044L161.43 76.7985C161.43 76.7985 166.574 73.6516 167.613 73.1135C168.652 72.5753 170.801 71.6073 170.801 71.6073L160.519 69.4284L155.781 74.8034L154.762 75.2497L150.574 69.4284L150.237 69.4415Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.833 67.85L155.129 74.2422L155.335 74.7115L155.781 74.8132L153.166 67.85H151.833Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.237 68.5162L154.962 75.0003H155.283L151.833 68.5162H150.237Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.166 67.2003L155.781 73.8747L158.775 68.7131L153.166 67.2003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.833 67.85L155.129 74.2422L155.335 74.7115L155.781 74.8132L153.166 67.85H151.833Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.237 68.5162L154.962 75.0003H155.283L151.833 68.5162H150.237Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.166 67.2003L155.781 73.8747L158.775 68.7131L153.166 67.2003Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.749 106.272C143.749 106.272 162.999 99.3812 170.821 96.0014C172.306 95.3547 173.862 94.8866 175.457 94.6068C177.381 94.2786 180.1 93.6223 181.912 92.3885C184.973 90.3015 187.195 86.0751 187.195 86.0751C187.195 86.0751 187.276 95.5715 179.33 97.7569L171.139 98.8562C171.139 98.8562 168.281 100.523 163.075 102.338C157.868 104.152 146.642 107.798 146.642 107.798C146.642 107.798 144.42 107.066 144.266 106.909C144.112 106.751 143.749 106.272 143.749 106.272Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.131 60.6277C177.131 59.5842 178.036 58.5571 178.036 58.5571C178.036 58.5571 179.523 55.5578 176.935 55.9877C181.145 55.2953 180.634 52.5258 181.627 55.0427C183.292 59.2626 177.331 60.6014 177.131 60.6277Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 79.7929,
    y1: 56.1353,
    x2: 95.8323,
    y2: 56.1353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 13.2069,
    y1: 124.658,
    x2: 261.699,
    y2: 124.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68E1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69B9EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 142.879,
    y1: 115.546,
    x2: 176.774,
    y2: 186.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#3C3A52",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 137.286,
    y1: 89.2581,
    x2: 149.798,
    y2: 152.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 11167.8,
    y1: 5562.65,
    x2: 10920.1,
    y2: 6258.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 3011.43,
    y1: 2104.41,
    x2: 3005.67,
    y2: 1985.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 6299.76,
    y1: 7568.72,
    x2: 9161.84,
    y2: 9597.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#3C3A52",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 15301.3,
    y1: 20325.7,
    x2: 170645,
    y2: 20325.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#3C3A52",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 3483.49,
    y1: 4173.04,
    x2: 3502.8,
    y2: 4475.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 11012.1,
    y1: 6932.64,
    x2: 19965.4,
    y2: 6932.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 12178.1,
    y1: 3481.19,
    x2: 12022.4,
    y2: 4818.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#3C3A52",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 17862.5,
    y1: 2411.46,
    x2: 20476.5,
    y2: 2411.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#3C3A52",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 5490.58,
    y1: 6889.36,
    x2: 6354.6,
    y2: 6889.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#3C3A52",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 5354.75,
    y1: 6621.81,
    x2: 6172.54,
    y2: 7224.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#3C3A52",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 3421.14,
    y1: 8632.88,
    x2: 5952.1,
    y2: 10098.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#3C3A52",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 9631.58,
    y1: 9690.68,
    x2: 18532.8,
    y2: 9690.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 6154.63,
    y1: 7964.72,
    x2: 8963.07,
    y2: 7462.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#3C3A52",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 2205.24,
    y1: 2032.88,
    x2: 2362.8,
    y2: 2032.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 409.367,
    y1: 812.192,
    x2: 463.717,
    y2: 856.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 1373.01,
    y1: 2350.9,
    x2: 1417.36,
    y2: 2350.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 1564.84,
    y1: 1575.57,
    x2: 1613.37,
    y2: 1575.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 2088.59,
    y1: 1300.06,
    x2: 2200.37,
    y2: 1300.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 12194.1,
    y1: 7791.87,
    x2: 12939.3,
    y2: 6191.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 17465.7,
    y1: 6373.12,
    x2: 18252.4,
    y2: 8554.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#3C3A52",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 10048.6,
    y1: 5389.35,
    x2: 11494.2,
    y2: 5389.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#3C3A52",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 22866.2,
    y1: 8722.74,
    x2: 23570.5,
    y2: 10817.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#3C3A52",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 3114.74,
    y1: 1779.64,
    x2: 3266.21,
    y2: 1779.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 1905.17,
    y1: 1092.98,
    x2: 1953.38,
    y2: 1092.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 10065.9,
    y1: 7579.06,
    x2: 14493.5,
    y2: 8800.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 6451.74,
    y1: 4431.08,
    x2: 6878.29,
    y2: 4431.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 12131.7,
    y1: 8522.74,
    x2: 13488.8,
    y2: 8522.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 9947.92,
    y1: 2278.24,
    x2: 11400.8,
    y2: 2849.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#3C3A52",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 1981.9,
    y1: 1581.51,
    x2: 2029.48,
    y2: 1581.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 2464.39,
    y1: 1486.46,
    x2: 2542.1,
    y2: 1486.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 2775.87,
    y1: 1501.93,
    x2: 2871.91,
    y2: 1501.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 19203.9,
    y1: 8214.18,
    x2: 24964.4,
    y2: 8214.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#3C3A52",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 2946.17,
    y1: 1697.44,
    x2: 2959.08,
    y2: 1691.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 79.2929,
    y1: 56.1353,
    x2: 95.3323,
    y2: 56.1353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 11167.3,
    y1: 5562.65,
    x2: 10919.6,
    y2: 6258.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 6299.26,
    y1: 7568.72,
    x2: 9161.34,
    y2: 9597.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#3C3A52",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 3482.99,
    y1: 4173.04,
    x2: 3502.3,
    y2: 4475.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 11011.6,
    y1: 6932.64,
    x2: 19964.9,
    y2: 6932.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 12177.6,
    y1: 3481.19,
    x2: 12021.9,
    y2: 4818.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#3C3A52",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 5490.08,
    y1: 6889.36,
    x2: 6354.1,
    y2: 6889.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#3C3A52",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 3420.64,
    y1: 8632.88,
    x2: 5951.6,
    y2: 10098.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#3C3A52",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 9631.08,
    y1: 9690.68,
    x2: 18532.3,
    y2: 9690.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 6154.13,
    y1: 7964.72,
    x2: 8962.57,
    y2: 7462.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#3C3A52",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 2204.74,
    y1: 2032.88,
    x2: 2362.3,
    y2: 2032.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 408.867,
    y1: 812.192,
    x2: 463.217,
    y2: 856.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 1372.51,
    y1: 2350.9,
    x2: 1416.86,
    y2: 2350.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 1564.34,
    y1: 1575.57,
    x2: 1612.87,
    y2: 1575.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 2088.09,
    y1: 1300.06,
    x2: 2199.87,
    y2: 1300.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 12193.6,
    y1: 7791.87,
    x2: 12938.8,
    y2: 6191.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 17465.2,
    y1: 6373.12,
    x2: 18251.9,
    y2: 8554.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#3C3A52",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 10048.1,
    y1: 5389.35,
    x2: 11493.7,
    y2: 5389.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#3C3A52",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 22865.7,
    y1: 8722.74,
    x2: 23570,
    y2: 10817.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#3C3A52",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 3114.24,
    y1: 1779.64,
    x2: 3265.71,
    y2: 1779.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 1904.67,
    y1: 1092.98,
    x2: 1952.88,
    y2: 1092.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 6451.24,
    y1: 4431.08,
    x2: 6877.79,
    y2: 4431.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 12131.2,
    y1: 8522.74,
    x2: 13488.3,
    y2: 8522.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 9947.42,
    y1: 2278.24,
    x2: 11400.3,
    y2: 2849.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#3C3A52",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 1981.4,
    y1: 1581.51,
    x2: 2028.98,
    y2: 1581.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 2463.89,
    y1: 1486.46,
    x2: 2541.6,
    y2: 1486.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 2775.37,
    y1: 1501.93,
    x2: 2871.41,
    y2: 1501.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 19203.4,
    y1: 8214.18,
    x2: 24963.9,
    y2: 8214.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#3C3A52",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 2945.67,
    y1: 1697.44,
    x2: 2958.58,
    y2: 1691.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECC4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#EFD4D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2EAC9"
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 270,
    height: 169,
    transform: "translate(0.5)"
  })))));
};
export default SvgInviteFriends;